<template>
    <div class="volume-wrap">
        <div class="volume">
            <div class="nav clearfix">
                <router-link to='/home'>
                    <img class="navBack pull-left" src="../../../static/images/shootShop/back.png" alt="">
                </router-link>
                <h2 class="navTitle pull-left">成交案例</h2>
            </div>
            <ul class="volumeMain">
                <li v-for="item in imgArr">
                    <img :src="item.pic">
                </li>
            </ul>

        </div>
    </div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'seekShop',
    data () {
        return {
            imgArr: [
                {
                    pic: "../../../static/images/volume/img1.png"},
                {
                    pic: "../../../static/images/volume/img2.png"},
                {
                    pic: "../../../static/images/volume/img3.png"},
                {
                    pic: "../../../static/images/volume/img4.png"},
                {
                    pic: "../../../static/images/volume/img5.png"},
                {
                    pic: "../../../static/images/volume/img6.png"},
                {
                    pic: "../../../static/images/volume/img7.png"},
                {
                    pic: "../../../static/images/volume/img8.png"},
                {
                    pic: "../../../static/images/volume/img9.png"},
                {
                    pic: "../../../static/images/volume/img10.png"},
                {
                    pic: "../../../static/images/volume/img11.png"},
                {
                    pic: "../../../static/images/volume/img12.png"},
                {
                    pic: "../../../static/images/volume/img13.png"},
                {
                    pic: "../../../static/images/volume/img14.png"},
                {
                    pic: "../../../static/images/volume/img15.png"},
                {
                    pic: "../../../static/images/volume/img16.png"},
                {
                    pic: "../../../static/images/volume/img17.png"},
                {
                    pic: "../../../static/images/volume/img18.png"},
                {
                    pic: "../../../static/images/volume/img19.png"},
                {
                    pic: "../../../static/images/volume/img20.png"},
                {
                    pic: "../../../static/images/volume/img21.png"},
                {
                    pic: "../../../static/images/volume/img22.png"},
                {
                    pic: "../../../static/images/volume/img23.png"},
                {
                    pic: "../../../static/images/volume/img24.png"},
                {
                    pic: "../../../static/images/volume/img25.png"},
                {
                    pic: "../../../static/images/volume/img26.png"},
                {
                    pic: "../../../static/images/volume/img27.png"},
                {
                    pic: "../../../static/images/volume/img28.png"},
                {
                    pic: "../../../static/images/volume/img29.png"},

            ]

        }
    },
    computed:{

    },
    updated(){

    },
    methods:{

    },
    mounted() {
        //截取Url里面的参数
        function GetRequest() {
            var url = location.search; //获取url中"?"符后的字串
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
        var request = new Object();
        request = GetRequest();
        this.move = request['move'];
        if(this.move == "ios"){
            $(".input-bottom").hide();
        }else if(this.move == "android"){
            $(".nav").hide();
            $(".volume").css("padding","0");
        }


    }
}
</script>

<style scoped lang="scss">
/*浮动*/
.pull-right{
    float: right;
}
.pull-left{

    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

input::-webkit-input-placeholder{
    color:#fff;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#fff;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#fff;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#fff;
}
/*内容部分*/
.volume-wrap{
    width: 7.5rem;
    margin: 0 auto;
    background: #fff;
}
.volume{
    width: 7.5rem;
    margin: 0 auto;
    background: #fff;
    padding-top: 1rem;
}
.nav{
    width: 6.9rem;
    height: .88rem;
    background: #fff;
    margin: 0 auto;
    padding:  0 0.3rem;
    position: fixed;
    top: 0;
    z-index: 99;
}
.nav a{
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.navBack{
    width: 0.2rem;
    height: 0.36rem;
    margin-top: 0.28rem;
}
.navTitle{
    height: .88rem;
    width: 6.4rem;
    line-height: .88rem;
    font-size: 0.36rem;
    color: #3c3c3c;
    text-align: center;
}
.volumeMain{
    width: 6.9rem;
    padding: 0 .3rem .5rem;
    li{
        width: 6.9rem;
        height: 5.1rem;
        margin-top: .2rem;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/home/volume.vue